import React from "react";
import logoImage from "../assets/logo.png"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';


export default function LoginPage() {
const navigate = useNavigate();

const handleLogin = (e) => {
  e.preventDefault();

  // Validasi atau kirim ke backend (mock dulu)
  const email = e.target.email.value;
  const password = e.target.password.value;

  if (email === 'kentbintoro@gmail.com' && password === 'x8sd#sA7') {
    Swal.fire({
        icon: "success",
        title: "Berhasil Login!",
        showConfirmButton: false,
        timer: 1500,
        timerProgressBar: true,
      }).then(() => {
        navigate("/dashboard");
      });
  } else {
    Swal.fire({
        icon: "error",
        title: "Login Gagal",
        text: "Email atau password salah!",
        confirmButtonColor: "#05990f",
      });
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="max-w-md w-full bg-white shadow-lg rounded-xl p-8">
        <div className="text-3xl font-bold text-center text-green-700 mb-2">
            <center>
             <img src={logoImage} alt="Logo Image" className="w-[150px] h-[120px]"/>
             </center>
        </div>

        <form onSubmit={handleLogin} className="space-y-5">
          <div>
            <label className="block mb-1 font-medium text-gray-700">Email</label>
            <input
              type="email"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="contoh@email.com" name="email"
            />
          </div>

          <div>
            <label className="block mb-1 font-medium text-gray-700">Password</label>
            <input
              type="password"
              className="w-full px-4 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-green-500"
              placeholder="********" name="password"
            />
          </div>

          <button
            type="submit"
            className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 transition"
          >
            Masuk
          </button>
        </form>

        {/* <p className="text-center text-sm text-gray-600 mt-4">
          Belum punya akun?{' '}
          <a href="/register" className="text-green-700 font-medium hover:underline">
            Daftar di sini
          </a>
        </p> */}
      </div>
    </div>
  );
}
